import {
    Grid, MenuItem, Box, Paper,
    Button, Stack, TextField, Modal, Typography,
    Divider
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Form from "../common/Form";
import Controls from "../controls/Controls";
import useForm from "../common/useForm";
import { useEffect, useState } from "react";
import { addNewClient, clientAdded, getClientAddedStatus } from "../../store/clients";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close"

const initialFormValues = {
    //issueStatus: "",
    id: 0,
    name: "",
    clientId: "",
    contactName: "",
    addedBy: 1,
};

const AddClient = (props) => {

    const { setNotify, setOpenPopup, selectedClient, handleAddClient } = props;
    const [validateOnChange, setValidateOnChange] = useState(true);
    const [clientObj, setClientObj] = useState({});

    const clientAddedStatusSelector = useSelector(getClientAddedStatus)

    const dispatch = useDispatch();
    const validate = (fieldValues = formValues) => {
        let temp = { ...errors };
        // if ("issueStatus" in fieldValues)
        //   temp.issueStatus = fieldValues.issueStatus
        //     ? ""
        //     : "This field is required.";
        if ("reviewNotes" in fieldValues)
            temp.reviewNotes = fieldValues.reviewNotes
                ? ""
                : "This field is required.";

        setErrors({ ...temp });
        if (fieldValues === formValues)
            return Object.values(temp).every((x) => x === "");
    };

    useEffect(() => {
        if (selectedClient) setClientObj(selectedClient);
        else setClientObj(initialFormValues);
    }, [selectedClient])

    const { formValues, errors, setErrors, handleOnChange, resetForm } = useForm(
        clientObj,
        validateOnChange,
        validate,
        setValidateOnChange
    );

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            dispatch(addNewClient(formValues));
        }
    };

    useEffect(() => {
        if (clientAddedStatusSelector) {
            setNotify({
                isOpen: true,
                message: `${formValues?.id === 0 ? "Added Successfully" : "Updated Successfully"}`,
                type: "success",
            });
            handleAddClient("save");
            resetForm();
        }

        return () => {
            dispatch(clientAdded(false))
        }
    }, [clientAddedStatusSelector])

    return <>
        <Form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Controls.Input
                        rows={3}
                        name="name"
                        label="Name"
                        onChange={handleOnChange}
                        value={formValues?.name}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Controls.Input
                        rows={3}
                        name="clientId"
                        label="ID"
                        onChange={handleOnChange}
                        value={formValues?.clientId}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Controls.Input
                        rows={3}
                        name="contactName"
                        label="Key Contact Name"
                        onChange={handleOnChange}
                        value={formValues?.contactName}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider sx={{ ml: -3, mr: -3, mb: 2 }} />
                    <Stack
                        spacing={2}
                        direction="row"
                        justifyContent="end"
                        alignItems="center"
                    >
                        <Controls.Button
                            text="Close"
                            color="error"
                            size="small"
                            variant="outlined"
                            onClick={() => handleAddClient(null)}
                            startIcon={<CloseIcon />}
                            sx={{
                                width:"80px",
                                '&:hover': {
                                    backgroundColor: 'red',
                                    color: 'white',
                                    border: 'none',
                                }
                            }}
                        ></Controls.Button>
                        <Controls.Button
                            text="Save"
                            type="submit"
                            size="small"
                            variant="outlined"
                            startIcon={<SaveIcon />}
                            sx={{
                                width:"80px",
                                color: 'black',
                                border: "1px solid black",
                                '&:hover': {
                                    backgroundColor: 'black',
                                    color: 'white',

                                }
                            }}
                        ></Controls.Button>
                    </Stack>
                </Grid>
            </Grid>
        </Form>
    </>
}

export default AddClient;